/**
 * Screenlux Fabric Sample Request Popup ("Gratis Stoffmuster")
 *
 * Opens on click of any [data-open-sample-request] element (e.g. the PDP
 * secondary CTA). Unlike the exit-intent survey, this is a deliberate click,
 * not an auto-trigger — no session gating, intent detection, or consent
 * checks needed to decide whether to show it.
 *
 * Submits to the Powerups app (/apps/measurements?action=request-sample) and
 * AWAITS the response (unlike the fire-and-forget survey post) because a real
 * shipping address only gets acted on if the save actually succeeded — the
 * visitor needs to know if it failed so they can retry.
 */
(function () {
  'use strict';

  var cfg = window.SampleRequestConfig || {};
  var el = document.getElementById('slx-sample');
  if (!el) return;

  var form = el.querySelector('[data-slx-sample-form]');
  var formStep = el.querySelector('[data-slx-sample-step="form"]');
  var thanksBox = el.querySelector('[data-slx-sample-thanks]');
  var errorEl = el.querySelector('[data-slx-sample-error]');
  var submitBtn = el.querySelector('[data-slx-sample-submit]');
  var submitText = el.querySelector('[data-slx-sample-submit-text]');
  var headingEl = el.querySelector('.sl-modal-heading');
  var subEl = el.querySelector('.sl-modal-sub');
  var shown = false;

  function ss(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function ssSet(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }

  // The campaign that brought this visitor, captured on the landing page by
  // attribution.js. location.href almost never still carries it by the time a
  // form is submitted.
  function attribution() {
    try { return window.slxAttribution ? window.slxAttribution.get() : {}; }
    catch (e) { return {}; }
  }
  // Long-lived first/last touch (90 days) from attribution.js, or null.
  function attrTouches() {
    try { return window.slxAttribution && window.slxAttribution.attr ? window.slxAttribution.attr() : null; }
    catch (e) { return null; }
  }

  function sessionId() {
    var id = ss('slx_sid');
    if (!id) {
      id = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      ssSet('slx_sid', id);
    }
    return id;
  }

  function open() {
    if (shown) return;
    shown = true;
    // Reset to the initial form view in case this is a reopen after a
    // previous successful submission (showThanks left these hidden/shown).
    if (formStep) formStep.hidden = false;
    if (thanksBox) thanksBox.hidden = true;
    if (headingEl) headingEl.hidden = false;
    if (subEl) subEl.hidden = false;
    el.style.display = 'flex';
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = el.querySelector('.sl-modal-close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    shown = false;
    el.style.display = 'none';
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function setBusy(busy) {
    if (!submitBtn) return;
    submitBtn.disabled = busy;
    if (submitText) submitText.textContent = busy ? (cfg.submitLoadingText || '…') : (cfg.submitText || 'Submit');
  }

  function showThanks() {
    if (formStep) formStep.hidden = true;
    if (headingEl) headingEl.hidden = true;
    if (subEl) subEl.hidden = true;
    if (thanksBox) thanksBox.hidden = false;
    setTimeout(close, 3000);
  }

  var triggers = document.querySelectorAll('[data-open-sample-request]');
  for (var i = 0; i < triggers.length; i++) {
    triggers[i].addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  }

  var closeEls = el.querySelectorAll('[data-slx-sample-close]');
  for (var c = 0; c < closeEls.length; c++) closeEls[c].addEventListener('click', close);
  el.addEventListener('click', function (e) { if (e.target === el) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && shown) close();
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var colors = Array.prototype.slice.call(form.querySelectorAll('input[name="color"]:checked')).map(function (cb) {
        return cb.value;
      });
      if (colors.length === 0) {
        showError(cfg.errorColors || 'Please select at least one color.');
        return;
      }

      var data = new FormData(form);
      var payload = {
        colors: colors,
        // Discrete parts so HubSpot gets a clean firstname/lastname rather than
        // a split of one blob. `name` is still sent because the metaobject
        // stores a single name and the shipping label prints it.
        firstName: (data.get('firstName') || '').toString().trim(),
        lastName: (data.get('lastName') || '').toString().trim(),
        email: (data.get('email') || '').toString().trim(),
        phone: (data.get('phone') || '').toString().trim(),
        addressLine1: (data.get('addressLine1') || '').toString().trim(),
        addressLine2: (data.get('addressLine2') || '').toString().trim(),
        city: (data.get('city') || '').toString().trim(),
        zip: (data.get('zip') || '').toString().trim(),
        country: (data.get('country') || '').toString().trim(),
        pageUrl: cfg.pageUrl || location.href,
        utm: attribution(),
        attr: attrTouches(),
        market: cfg.market || '',
        sessionId: sessionId()
      };

      payload.name = (payload.firstName + ' ' + payload.lastName).trim();

      if (!payload.firstName || !payload.lastName || !payload.email || !payload.phone || !payload.addressLine1 || !payload.city || !payload.zip || !payload.country) {
        showError(cfg.errorFields || 'Please fill in all required fields.');
        return;
      }

      setBusy(true);
      fetch((cfg.proxyBase || '/apps/measurements') + '?action=request-sample', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (!res.ok) throw new Error('request-sample failed');
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'sample_requested', { market: cfg.market || '', colors: colors.join(',') });
          }
        } catch (err) {}
        showThanks();
      }).catch(function () {
        setBusy(false);
        showError(cfg.errorGeneric || 'Something went wrong. Please try again.');
      });
    });
  }
})();
